import React from "react";
import "../assets/styles/components/Services.css";
import locationBureau from "../assets/images/location-de-bureaux.jpg";
import salleReunion from "../assets/images/salle-de-reunion-equipee.jpg";
import coworking from "../assets/images/espaces-de-coworking.jpg";

const servicesData = [
  {
    title: "Location de Bureaux Privés",
    description: `
      Profitez de nos bureaux privés à Villiers-Le-Bel, idéalement situés pour répondre à vos besoins professionnels.
      Nos bureaux sont entièrement équipés avec du mobilier moderne et une connexion internet haut débit, garantissant
      un environnement de travail confortable et productif. Que vous soyez une start-up en pleine croissance ou une
      entreprise établie, nos espaces s'adaptent à vos exigences. De plus, vous bénéficierez d'un accès sécurisé 24/7,
      vous permettant de travailler à votre propre rythme. Venez découvrir nos solutions flexibles et personnalisées
      pour booster votre activité.`,
    image: locationBureau,
  },
  {
    title: "Salles de Réunion Équipées",
    description: `
      Organisez vos réunions dans nos salles parfaitement aménagées, dotées de technologies de pointe pour faciliter vos
      présentations et discussions. Chaque salle est équipée de matériel audiovisuel moderne, de tableaux blancs et d'une
      connexion Wi-Fi fiable pour assurer le bon déroulement de vos rencontres. Nos espaces peuvent accueillir des groupes
      de différentes tailles, que ce soit pour des réunions d'affaires, des ateliers ou des séminaires. Notre équipe est à
      votre disposition pour vous aider à organiser et personnaliser votre événement selon vos besoins spécifiques.
      Réservez dès maintenant et faites de vos réunions un succès.`,
    image: salleReunion,
  },
  {
    title: "Espaces de Coworking",
    description: `
      Rejoignez notre communauté dynamique dans nos espaces de coworking à Villiers-Le-Bel et profitez d'un environnement
      stimulant. Nos bureaux partagés sont conçus pour favoriser la collaboration et l'innovation entre professionnels de
      divers secteurs. Vous bénéficierez de tous les équipements nécessaires pour travailler efficacement, y compris des
      postes de travail ergonomiques et une connexion internet rapide. Nos espaces de coworking offrent également des zones
      de détente pour échanger et se ressourcer. Intégrez un réseau professionnel enrichissant et développez votre activité
      dans un cadre inspirant.`,
    image: coworking,
  },
];

const Services = () => (
  <section id="services" className="py-5 bg-violet-claire">
    <div className="container text-center">
      <h2 className="mb-4">Nos services de qualité</h2>
      <p className="text-muted mb-5">Découvrez nos offres de services</p>
      <div className="row">
        {servicesData.map((service, index) => (
          <div className="col-md-4 mb-4" key={index}>
            <div className="card shadow-sm h-100">
              <img
                src={service.image}
                className="card-img-top"
                alt={service.title}
              />
              <div className="card-body">
                <h3 className="card-title">{service.title}</h3>
                <p className="card-text">{service.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
